import { render } from "./ScoreCardTemplate.vue?vue&type=template&id=9b3379ae"
import script from "./ScoreCardTemplate.vue?vue&type=script&lang=js"
export * from "./ScoreCardTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.26_vue@3.5.26_typescript@5.4.2__webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__